import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'lib-year-select',
  templateUrl: './year-select.component.html',
  styleUrls: ['./year-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class YearSelectComponent implements OnInit, AfterViewInit {
  @Input() yearRangeMin: number;
  @Input() yearRangeMax: number;
  @Input() initialYear: number;
  @Input() minYear: number;
  @Input() maxYear: number;

  @Input() set focusYear(value: number) {
    if (value) {
      (document.activeElement as HTMLElement)?.blur();
      const element = document.querySelector(`#year-${value}`) as HTMLElement;
      if (element) {
        element.focus();
      }
    }
  }

  @Output() selectedYear = new EventEmitter<number>();

  @ViewChild('datepickerTableRef')
  datepickerTableRef: ElementRef;

  yearArray: number[][];

  ngOnInit(): void {
    this.calcYears();
  }

  ngAfterViewInit(): void {
    const initScroll = this.initialYear ?? new Date().getFullYear();
    const initYear = document.querySelector(`#year-${initScroll}`);
    if (initYear) {
      initYear.scrollIntoView({ block: 'center' });
    }

    this.focusYear = this.initialYear;
  }

  selectYear(year: number) {
    if (year > this.maxYear || year < this.minYear) {
      return;
    }
    this.selectedYear.emit(year);
  }

  private calcYears() {
    this.yearArray = Array.from(
      { length: (this.yearRangeMax - this.yearRangeMin + 1) / 3 },
      (_v, i) =>
        Array.from({ length: 3 }, (_y, j) => this.yearRangeMin + i * 3 + j),
    );
  }
}
